import React, { useState, useEffect } from "react";
import { utils } from "ethers";
import './styles.scss'
import { Contract } from "@ethersproject/contracts";
// import claimForm from "./claimForm";
import {
  // useSendTransaction,
  useContractCall,
  useEthers,
  useContractFunction,
  useTokenBalance,
} from "@usedapp/core";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import axios from "axios";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
// import MDInput from "components/MDInput";
import Divider from "@mui/material/Divider";
import icon2 from "../../assets/images/icon2.png"
import icon3 from "../../assets/images/icon3.png"
import MDTypography from "components/MDTypography";
import { CircularProgress, TextField } from "@material-ui/core";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// import DataTable from "examples/Tables/DataTable";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { formatUnits } from "@ethersproject/units";
import { BigNumber } from "@ethersproject/bignumber";

// Material Dashboard 2 PRO React context
import { useMaterialUIController, setOpenConfigurator } from "context";

import stakingABI from "../../abi/stakingCLIFF.json";
import approvalABI from "../../abi/approvalCLIFF.json";
// import redABI from "../../abi/redABI.json";

// utils
import {
  // getCLIFFItem,
  // portfolio,
  coingeckoCLIFF,
  // transfers, // balance
  // getCLIFFBalanceTransfers,
} from "./utils";

axios.defaults.headers.get["Content-Type"] = "application/x-www-form-urlencoded";

// Create our number formatter.
const formatter = new Intl.NumberFormat("en-US", {});
const formatterUS = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

// Contracts
const wethApprovalContractAddress = "0x1B9BAF2A3EdeA91eE431f02d449a1044d5726669";
const contractSCLIFF = "0xfd0d8e8f509e6869400ccb9730a06c25172ec119";
const contractRED = "0x31339d225bd6fb6b1f6ab440780f35f6d32863ba";

const wethApprovalInterface = new utils.Interface(approvalABI);
const wethStakingInterface = new utils.Interface(stakingABI);
// const wethREDInterface = new utils.Interface(redABI);

export function useAllowance(account) {
  const owner = account;
  const spender = contractSCLIFF;
  const [allowance] =
    useContractCall(
      owner && {
        abi: wethApprovalInterface,
        address: wethApprovalContractAddress,
        method: "allowance",
        args: [owner, spender],
      }
    ) ?? [];
  return allowance;
}

export function useUserInfo(account) {
  const address = account;
  const [amount, rewardDebt, lastDepositedAt] =
    useContractCall(
      address && {
        abi: wethStakingInterface,
        address: contractSCLIFF,
        method: "userInfo",
        args: [address],
      }
    ) ?? [];
  return [amount, rewardDebt, lastDepositedAt];
}
export function usePendingReward(account) {
  const user = account;
  const [pendingReward] =
    useContractCall(
      user && {
        abi: wethStakingInterface,
        address: contractSCLIFF,
        method: "pendingReward",
        args: [user],
      }
    ) ?? [];
  return [pendingReward];
}

export function useStakedSupply() {
  const [stakedSupply] =
    useContractCall({
      abi: wethStakingInterface,
      address: contractSCLIFF,
      method: "stakedSupply",
      args: [],
    }) ?? [];
  return [stakedSupply];
}

export function useRewardPerBlock() {
  const [rewardPerBlock] =
    useContractCall({
      abi: wethStakingInterface,
      address: contractSCLIFF,
      method: "rewardPerBlock",
      args: [],
    }) ?? [];
  return [rewardPerBlock];
}


function Claims() {
    const { account } = useEthers();
  // const tokenBalance = useTokenBalance(contractSCLIFF, account);
  const [sCliffInfo] = useUserInfo(account);

  const [rewardDebt] = usePendingReward(account);
  const [totalSupply] = useStakedSupply();
  const totalSupplyF = totalSupply ? formatUnits(totalSupply, 18) : 0;
  const [rewardPerBlock] = useRewardPerBlock();
  const rewardPerBlockF = rewardPerBlock ? formatUnits(rewardPerBlock, 9) : 0;

  const cliffTokenBalance = useTokenBalance(wethApprovalContractAddress, account);
  const allowance = useAllowance(account);
  const allowanceF = allowance ? formatUnits(allowance, 18) : 0;

  const redTokenBalance = useTokenBalance(contractRED, account);

  //  console.log("redTokenBalance ", redTokenBalance);
  const [controller, dispatch] = useMaterialUIController();
  const { openConfigurator } = controller;
  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  const [disabled, setDisabled] = useState(false);
  const [disabledApproved, setDisabledApproved] = useState(allowanceF && allowanceF > 0);

  const [cliffPrice, setCLIFFPrice] = useState(0);
  const [cliffPriceUSD, setCLIFFPriceUSD] = useState(0);
  const [cliffBalanceLoader, setCLIFFBalanceLoader] = useState(0);

  const [stakingCLIFFAmount, setStakingCLIFFAmount] = useState(0);
  const [unStakingCLIFFAmount, setUnStakingCLIFFAmount] = useState(0);

  const [approvalError, setApprovalError] = useState(null);

  const contractStakingETH = new Contract(contractSCLIFF, wethStakingInterface);
  const contractApprovalETH = new Contract(wethApprovalContractAddress, wethApprovalInterface);

  // transactionName: "Wrap"
  const { state, send: useDeposit } = useContractFunction(contractStakingETH, "deposit", {});
  const { state: stateWithdraw, send: useWithdraw } = useContractFunction(
    contractStakingETH,
    "withdraw",
    {}
  );

  const { state: stateApprove, send: useApprove } = useContractFunction(
    contractApprovalETH,
    "approve",
    {}
  );

  // 1. APPROVE
  useEffect(() => {
    // console.log("stateApprove ", stateApprove);

    if (stateApprove.status === "Success") {
      setDisabled(false);
      setDisabledApproved(true);
    }
    if (stateApprove.status === "Exception" || state.status === "Fail") {
      setDisabled(false);
      setApprovalError(stateApprove.errorMessage);
    }
  }, [stateApprove]);

  // 2. DEPOSIT
  useEffect(() => {
    // console.log(" state ", state);
    if (
      state.status !== "Mining" &&
      state.status !== "Exception" &&
      state.status !== "PendingSignature" &&
      state.status !== "Fail"
    ) {
      setDisabled(false);
      setStakingCLIFFAmount(0);
      /* const scliff = SCLIFFBalance();
      setSCLIFFBalance(scliff); */
    }
    if (state.status === "Exception" || state.status === "Fail") {
      setDisabled(false);
      setApprovalError(state.errorMessage);
    }
  }, [state]);

  // 3. WITHDRAWAL
  useEffect(() => {
    // console.log(" stateWithdraw ", stateWithdraw);
    if (
      stateWithdraw.status !== "Mining" &&
      stateWithdraw.status !== "Exception" &&
      stateWithdraw.status !== "PendingSignature" &&
      stateWithdraw.status !== "Fail"
    ) {
      setDisabled(false);
      setUnStakingCLIFFAmount(0);
      /* const scliff = SCLIFFBalance();
      setSCLIFFBalance(scliff); */
    }
    if (stateWithdraw.status === "Exception" || stateWithdraw.status === "Fail") {
      setDisabled(false);
      setApprovalError(stateWithdraw.errorMessage);
    }
  }, [stateWithdraw]);

  const approveCLIFF = () => {
    try {
      setDisabled(true);
      setApprovalError(null);
      const maxAllowance = BigNumber.from("1000000000000000000").mul("1000000000000000000");

      useApprove(contractSCLIFF, maxAllowance);
    } catch (e) {
      console.log(e);
    }
  };

  const depositCLIFF = (depo) => {
    try {
      setDisabled(true);
      setApprovalError(null);

      const stake = depo
        ? BigNumber.from(0)
        : BigNumber.from(stakingCLIFFAmount).mul("1000000000000000000");
      useDeposit(stake);
    } catch (e) {
      setDisabled(false);
      setApprovalError(e.message);

      console.log(e);
    }
  };
  const withdrawCLIFF = () => {
    try {
      setDisabled(true);
      setApprovalError(null);
      const unstake = BigNumber.from(unStakingCLIFFAmount).mul("1000000000000000000");

      useWithdraw(unstake);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setDisabledApproved(allowanceF && allowanceF > 0);
    // console.log("Allowance ", allowanceF);
  }, [allowance]);

  useEffect(() => {
    const fetchCLIFFPrice = async () => {
      setCLIFFBalanceLoader(1);

      try {
        const cliffResponse = await coingeckoCLIFF();
        const price = cliffResponse.data["clifford-inu"].eth;
        const priceUSD = cliffResponse.data["clifford-inu"].usd;
        setCLIFFPrice(price);
        setCLIFFPriceUSD(priceUSD);
      } catch (error) {
        console.error(error.message);
      }
      setCLIFFBalanceLoader(0);
    };

    const refresh = async () => {
      await Promise.all([
        fetchCLIFFPrice(),
        // fetchApproved(account),
        // fetchPrice(CLIFF_Contract),
      ]);
    };

    if (account) {
      refresh();
      if (openConfigurator) {
        handleConfiguratorOpen();
      }
    } else if (!openConfigurator) {
      handleConfiguratorOpen();
    }
  }, [account]);

  const disableMessage = disabledApproved ? "Already approved" : "Approve $CLIFF";
  return account ? (<DashboardLayout>
      <DashboardNavbar />
      <div className="claimForm">
            <div className="bgColor"></div>
            <div className="claimIcon">
            <svg width="164" height="120" viewBox="0 0 164 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M76.1928 38.6655H67.7998C67.7998 38.6655 69.7646 37.016 67.9211 33.5958C67.9211 33.5958 69.2552 31.3398 71.778 31.3398C74.3007 31.3398 76.023 32.7225 76.023 32.7225C76.023 32.7225 77.6482 33.9839 78.0848 36.4096C78.3031 37.5982 77.3813 38.6655 76.1928 38.6655Z" fill="#696277"/>
                <path d="M82.6697 89.9934L82.0876 61.5156C77.0663 61.7825 72.9426 61.9765 71.56 62.0008C71.1719 62.0008 70.808 62.025 70.4199 62.025C70.1773 62.025 69.9105 62.0493 69.6679 62.0493C68.6491 62.0978 67.6546 62.1463 66.6358 62.1706C66.369 62.1706 66.1264 62.1948 65.8596 62.1948C65.5927 62.1948 65.3502 62.2191 65.0833 62.2191C64.8893 62.2191 64.7195 62.2191 64.5254 62.2191C64.3799 62.2191 64.2343 62.2191 64.1131 62.2191C63.8705 62.2191 63.6522 62.2191 63.4096 62.2191C63.3368 62.2191 63.2398 62.2191 63.167 62.2191C63.07 62.2191 62.9487 62.2191 62.8517 62.2191C62.6576 62.2191 62.4636 62.2191 62.2695 62.2191C62.318 66.4398 62.6091 84.6569 62.9245 88.635C63.2641 92.686 64.3556 95.5968 68.3338 97.9255H72.1664C73.1367 97.9255 77.2119 97.9255 77.2119 97.9255C83.7613 96.3973 82.6697 89.9934 82.6697 89.9934Z" fill="#1AE1FF"/>
                <path d="M97.1261 22.2918C92.9054 22.2918 89.9945 22.6557 88.7089 22.6557C87.4233 22.6557 85.2401 20.1087 83.6149 20.3512C81.9897 20.5938 77.9873 27.7254 76.0467 32.7466C76.0467 32.7466 77.6719 34.008 78.1085 36.4337C78.3026 37.598 77.4051 38.6653 76.2165 38.6653H67.8235C67.8235 38.6653 69.7884 37.0159 67.9448 33.5956C67.9448 33.5956 66.6349 31.0244 65.131 28.5501C63.6271 26.0759 62.4385 24.6933 61.6137 24.572C60.789 24.4507 53.997 24.8146 53.997 24.8146C53.997 24.8146 51.7654 23.6745 49.4852 23.0195C47.1808 22.3646 43.7363 22.025 41.8927 25.5665C40.0735 29.0838 41.4561 33.2075 42.6932 34.7842C43.9546 36.3367 45.5313 37.9861 50.7708 38.4228V39.5143C50.7708 39.5143 49.3154 39.6114 47.3021 39.6356C40.6314 43.4925 42.1838 52.0552 42.3779 56.6883C42.4021 57.4888 42.4992 58.6532 42.6447 60.0843C43.2996 66.9733 44.9491 79.8538 45.4828 85.8211C46.1377 93.0497 47.3021 95.2571 47.3021 95.2571C47.3021 95.2571 48.9515 98.0466 52.105 98.3377C55.2826 98.6288 59.6489 98.4833 60.692 98.4833C60.8132 98.4833 60.9103 98.4833 61.0316 98.459C61.7593 98.3862 62.5355 98.0952 63.8939 97.9739V97.9254C58.0722 97.2462 56.1074 96.4942 53.997 94.1898C53.051 93.1467 52.5658 91.9096 52.2748 90.4299C51.9352 88.6106 51.9109 86.4275 51.7411 83.7835C51.5228 80.533 50.5283 69.4233 49.8733 60.9333C49.558 56.8096 49.3154 53.3166 49.2911 51.5701C49.1941 46.2578 52.0079 42.6192 54.7005 42.0613C55.8163 41.8188 57.8539 41.6975 60.0128 41.6004C61.4439 41.5519 62.9721 41.5277 64.3063 41.5277C65.7617 41.5277 67.0473 41.5277 67.8721 41.5519C67.9206 41.5519 67.9933 41.5519 68.0419 41.5519C68.1631 41.5519 68.2844 41.5519 68.4057 41.5519C68.4785 41.5519 68.527 41.5519 68.5998 41.5519C69.2547 41.5762 70.0067 41.6004 70.7829 41.6247C70.9042 41.6247 71.0255 41.6247 71.1468 41.649C71.923 41.6732 72.7477 41.7217 73.5967 41.7702C74.1061 41.7945 74.6155 41.8188 75.1492 41.843C75.2219 41.843 75.319 41.843 75.3917 41.8673C76.7016 41.94 78.0358 42.0128 79.2729 42.0856C83.2268 42.3282 84.2941 45.6999 84.6337 49.6053C84.9005 52.8072 84.7065 56.1304 84.4154 61.3214C84.3669 62.4373 84.2941 63.6501 84.2213 64.9357C83.9545 70.248 83.4694 82.4979 82.6446 89.9205C82.6446 89.9205 83.7119 96.3244 77.211 97.9011C77.211 97.9011 77.7204 98.556 78.7635 98.6288C79.8065 98.7016 86.1376 98.6288 86.9381 98.6288C87.7143 98.6288 89.2183 98.3377 90.2613 96.2274C90.2613 96.2274 91.5955 93.4621 91.7168 91.473C91.8138 89.8963 93.6816 70.9515 94.4093 60.7878C94.6034 58.0952 94.7246 56.0091 94.7246 55.0389C94.6761 51.8369 94.7246 46.9855 94.0697 45.0449C93.4148 43.1286 92.0564 41.0183 88.5391 40.5331V39.9267C88.5391 39.9267 95.0157 39.9267 95.5979 39.9267C96.1801 39.9267 97.4172 40.6302 100.182 40.8727C100.182 40.8727 100.11 39.0292 98.3875 38.447C96.6652 37.8891 93.4148 38.1317 93.4148 38.1317V37.1371C93.4148 37.1371 97.2474 37.5253 99.9399 35.5362C102.802 33.4258 103.021 30.8788 103.093 29.2779C103.19 27.7254 102.172 22.2918 97.1261 22.2918ZM65.1795 36.3124L58.6786 36.8218C57.5143 34.2991 58.3875 30.7818 58.3875 30.7818C58.3875 30.7818 59.4791 26.7309 60.9588 26.27C62.4385 25.8091 65.6889 32.6011 66.4651 33.8139C67.2656 35.0025 68.4057 36.8218 65.1795 36.3124ZM86.0406 30.3209C86.0406 30.3209 86.4772 32.8679 84.852 34.1778C83.2268 35.4877 80.8981 35.6817 79.661 35.5604L86.0406 30.3209ZM101.201 31.5095C100.085 34.2748 98.0479 35.0753 96.2771 35.5604C96.2286 35.5847 96.1558 35.5847 96.083 35.5847C94.094 35.5362 88.3935 28.2591 88.3935 28.2591C88.3935 28.2591 91.8623 25.6393 93.4148 24.7418C94.9672 23.8443 97.684 23.2864 99.2365 24.3294C100.789 25.3725 102.317 28.7442 101.201 31.5095Z" fill="#544D5F"/>
                <path d="M98.4127 30.5148L96.0597 35.5846C96.0597 35.5846 94.1919 35.536 89.6316 36.191C85.0713 36.8459 79.6377 35.536 79.6377 35.536C80.8991 35.6573 83.2035 35.4875 84.8287 34.1534C86.4539 32.8435 86.0173 30.2965 86.0173 30.2965L88.3702 28.2589C88.3702 28.2589 95.0895 27.6768 95.3563 27.6768C95.6474 27.701 98.4127 30.5148 98.4127 30.5148Z" fill="#46414F"/>
                <path d="M68.3586 97.9496H65.278C64.7443 97.9496 64.2835 97.9739 63.8711 98.0224V97.9739C58.0494 97.2947 56.0846 96.5427 53.9742 94.2383C53.0282 93.1952 52.543 91.9581 52.252 90.4784L52.9797 61.3457C55.3326 61.6368 57.3459 61.8551 58.5588 62.0006C58.9469 62.0492 59.335 62.0734 59.7231 62.1219C59.8929 62.1462 60.087 62.1462 60.2568 62.1704C60.4994 62.1947 60.7177 62.1947 60.9602 62.219C61.2513 62.2432 61.5667 62.2432 61.8578 62.2675C62.0033 62.2675 62.1488 62.2675 62.2944 62.2675C62.3429 66.4882 62.634 84.7053 62.9493 88.6834C63.2889 92.7101 64.3805 95.6209 68.3586 97.9496Z" fill="#0092FF"/>
                <path d="M47.3021 95.2815C43.7363 94.9904 39.1759 92.6132 38.521 88.7564C37.8661 84.8995 35.7314 59.2598 35.7314 59.2598C35.7314 59.2598 38.7393 59.6236 42.6205 60.0845C43.2754 66.9735 44.9249 79.8298 45.4585 85.8213C46.1377 93.0741 47.3021 95.2815 47.3021 95.2815Z" fill="#0092FF"/>
                <path d="M42.3784 56.7119C42.4027 57.5124 42.4997 58.6767 42.6452 60.1079C38.7641 59.647 35.7562 59.2831 35.7562 59.2831C32.8696 58.7495 32.1904 55.8144 32.1904 51.812C32.1904 47.8096 33.282 45.6507 35.4409 43.5403C37.5998 41.4299 42.6452 39.6834 45.5076 39.6834C46.1382 39.6834 46.7447 39.6834 47.3026 39.6592C40.6319 43.5161 42.1843 52.0788 42.3784 56.7119Z" fill="#3BC3E9"/>
                <path d="M52.9788 61.3453L52.2511 90.478C51.9115 88.6588 51.8872 86.4756 51.7174 83.8316C51.4991 80.5812 50.5046 69.4714 49.8496 60.9814C50.9412 61.1027 51.9842 61.224 52.9788 61.3453Z" fill="#0076EE"/>
                <path d="M84.4399 61.3701C84.3913 62.4859 84.3186 63.6745 84.2458 64.9844C83.979 70.2967 83.4938 82.5465 82.6691 89.9692L82.0869 61.4914C82.8631 61.4671 83.6394 61.4186 84.4399 61.3701Z" fill="#0076EE"/>
                <path d="M84.4397 61.3705C83.6392 61.4191 82.863 61.4433 82.0868 61.4918C77.0656 61.7586 72.9419 61.9527 71.5592 61.977C71.1711 61.977 70.8072 62.0012 70.4191 62.0012C70.1766 62.0012 69.9097 62.0255 69.6672 62.0255C68.6484 62.074 67.6538 62.1225 66.635 62.1468C66.3682 62.1468 66.1256 62.171 65.8588 62.171C65.592 62.171 65.3494 62.1953 65.0826 62.1953C64.8885 62.1953 64.7187 62.1953 64.5247 62.1953C64.3791 62.1953 64.2336 62.1953 64.1123 62.1953C63.8697 62.1953 63.6514 62.1953 63.4088 62.1953C63.0692 59.527 62.2203 50.5761 65.1796 47.0831C67.7266 44.0752 72.6993 42.4743 75.1735 41.8193C75.2463 41.8193 75.3433 41.8193 75.4161 41.8436C76.726 41.9164 78.0601 41.9891 79.2972 42.0619C83.2511 42.3045 84.3184 45.6762 84.658 49.5816C84.9491 52.8563 84.7308 56.1553 84.4397 61.3705Z" fill="#7DEEFF"/>
                <path d="M75.1989 41.8917C72.7004 42.5224 67.7277 44.1476 65.205 47.1555C62.2698 50.6485 63.1189 59.5994 63.4342 62.2677C63.3614 62.2677 63.2644 62.2677 63.1916 62.2677C63.0946 62.2677 62.9733 62.2677 62.8763 62.2677C62.6822 62.2677 62.4882 62.2677 62.2941 62.2677C62.1486 62.2677 62.003 62.2677 61.8575 62.2677C61.5664 62.2677 61.2511 62.2434 60.96 62.2191C60.7174 62.2191 60.4991 62.1949 60.2565 62.1706C60.0867 62.1706 59.8927 62.1464 59.7229 62.1221C59.359 62.0979 58.9709 62.0493 58.5585 62.0008C57.3457 61.8553 55.3081 61.6127 52.9794 61.3459C51.9849 61.2246 50.9175 61.1033 49.8502 60.982C49.5349 56.8583 49.2923 53.3653 49.2681 51.6188C49.171 46.3065 51.9849 42.6679 54.6774 42.11C57.3457 41.5521 65.1079 41.5521 67.8732 41.6006C67.9217 41.6006 67.9945 41.6006 68.043 41.6006C68.1643 41.6006 68.2856 41.6006 68.4069 41.6006C68.4797 41.6006 68.5282 41.6006 68.6009 41.6006C69.2559 41.6249 70.0079 41.6491 70.7841 41.6734C70.9054 41.6734 71.0267 41.6734 71.1479 41.6977C71.9242 41.7219 72.7489 41.7704 73.6222 41.8189C74.1558 41.8432 74.6652 41.8675 75.1989 41.8917Z" fill="#3BC3E9"/>
                <path d="M108.067 60.0605C108.067 60.0605 106.248 86.3552 105.908 88.975C105.568 91.5947 103.288 94.6026 99.4799 95.4516C95.6715 96.3006 90.335 96.2521 90.335 96.2521C90.335 96.2521 91.6691 93.4868 91.7904 91.4977C91.8874 89.921 93.7552 70.9762 94.4829 60.8125C101.809 60.4244 108.067 60.0605 108.067 60.0605Z" fill="#1EE3FF"/>
                <path d="M111.584 57.6832C111.244 60.1817 108.066 60.0847 108.066 60.0847C108.066 60.0847 101.832 60.4486 94.4825 60.8367C94.6766 58.1441 94.7979 56.058 94.7979 55.0877C94.7493 51.8858 94.7979 47.0344 94.1429 45.0938C93.488 43.1775 92.1296 41.0429 88.6123 40.582V39.9756C88.6123 39.9756 95.0889 39.9756 95.6711 39.9756C96.2533 39.9756 97.4904 40.679 100.256 40.9216C105.471 41.431 109.352 44.8027 110.395 46.9859C111.948 50.3091 111.972 54.6511 111.584 57.6832Z" fill="#7DEEFF"/>
                <path d="M101.202 31.534C100.086 34.2993 98.0488 35.0997 96.2781 35.5849C94.4831 36.0943 88.3945 28.2835 88.3945 28.2835C88.3945 28.2835 91.8633 25.6637 93.4157 24.7662C94.9682 23.8687 97.685 23.3108 99.2374 24.3539C100.79 25.3727 102.318 28.7444 101.202 31.534Z" fill="#1C1931"/>
                <path d="M65.1807 36.3129L58.3887 30.7823C58.3887 30.7823 59.4802 26.7313 60.9599 26.2704C62.4396 25.8096 65.6901 32.6015 66.4663 33.8144C67.2668 35.003 68.4068 36.8223 65.1807 36.3129Z" fill="#1C1931"/>
                <path d="M85.6532 57.9737C85.5076 60.1326 84.974 72.819 84.8042 75.463C84.6344 78.0828 83.9552 87.2277 83.5913 89.5806C83.5913 89.5806 85.2166 96.0815 78.8127 98.677C77.7454 98.6043 77.2602 97.9493 77.2602 97.9493C83.7611 96.3726 82.6938 89.9688 82.6938 89.9688C83.4943 82.5461 84.0037 70.2963 84.2705 64.984C84.3433 63.6741 84.4161 62.4855 84.4646 61.3697C84.7557 56.1544 84.974 52.8554 84.6829 49.6535C84.3676 45.7481 83.276 42.3764 79.3221 42.1338C78.085 42.061 76.7508 41.9883 75.441 41.9155C75.3682 41.9155 75.2712 41.9155 75.1984 41.8912C74.689 41.867 74.1553 41.8427 73.6459 41.8185C72.7969 41.77 71.9722 41.7214 71.196 41.6972C71.0747 41.6972 70.9534 41.6972 70.8321 41.6729C70.0316 41.6487 69.3039 41.6002 68.649 41.6002C68.5762 41.6002 68.5277 41.6002 68.4549 41.6002C68.3336 41.6002 68.2123 41.6002 68.0911 41.6002C68.0425 41.6002 67.9698 41.6002 67.9213 41.6002C67.0965 41.5759 65.8109 41.5759 64.3555 41.5759C64.3555 41.5759 66.8054 40.6299 69.6193 40.6299C72.4331 40.6299 78.5459 40.6784 80.5107 41.0908C82.4755 41.5031 84.4888 42.4977 85.3378 45.9664C86.1141 49.4352 85.7987 55.8148 85.6532 57.9737Z" fill="#2D222D"/>
                <path d="M63.8696 97.9737V98.0222C62.5112 98.1435 61.735 98.4346 61.0073 98.5074C54.7975 97.7069 53.4391 95.2326 52.4931 94.4322C51.45 93.5347 50.9891 89.702 50.9891 87.2036C50.9891 84.7293 50.1887 80.2175 50.0431 76.9671C49.8976 73.7166 49.0001 62.7767 48.7818 59.7931C48.5392 56.7852 48.1753 51.861 48.3694 49.6051C48.5634 47.3492 49.3639 44.2443 52.1292 42.4493C54.9188 40.63 59.94 41.6003 59.94 41.6003L59.9643 41.673C57.8054 41.7458 55.7678 41.8914 54.652 42.1339C51.9837 42.6918 49.1456 46.3304 49.2426 51.6427C49.2669 53.3649 49.5095 56.8822 49.8248 61.0059C50.4797 69.5202 51.4743 80.6056 51.6926 83.8561C51.8867 86.5001 51.8867 88.6832 52.2263 90.5025C52.4931 92.0065 52.9782 93.2436 53.9485 94.2624C56.0831 96.5425 58.0479 97.2945 63.8696 97.9737Z" fill="#473945"/>
                <path d="M58.4115 39.3931C58.4115 39.3931 55.3066 40.0481 50.7705 39.5144V38.4229C50.7705 38.4229 56.3739 38.4956 58.4115 39.3931Z" fill="#473945"/>
                <path d="M93.4634 37.2098V38.2043C92.2748 38.5439 85.8467 37.986 85.8467 37.986C87.763 36.9915 93.4634 37.2098 93.4634 37.2098Z" fill="#473945"/>
                <path d="M50.7717 38.4229C45.5322 38.0105 43.9555 36.361 42.6941 34.7843C41.4327 33.2076 40.0501 29.0839 41.8936 25.5666C43.7129 22.0493 47.1817 22.3647 49.4861 23.0196C51.7905 23.6746 53.9979 24.8146 53.9979 24.8146C53.9979 24.8146 48.7584 27.9923 50.7717 38.4229Z" fill="#46414F"/>
                <path d="M119.321 6.42773C119.321 6.42773 122.96 12.6133 129.534 12.0554V20.8849C129.534 20.8849 122.45 21.079 119.321 14.9905V6.42773Z" fill="#1989F7"/>
                <path d="M151.171 46.6223C151.171 46.6223 155.683 53.2688 163.493 50.6248V41.9165C155.658 44.5362 151.171 37.9141 151.171 37.9141V46.6223Z" fill="#1989F7"/>
                <path d="M138.071 85.7004C140.133 85.6033 141.589 82.9836 141.589 82.9836V76.0703C141.589 76.0703 140.133 78.6901 138.071 78.7871V85.7004Z" fill="#F8D7BC"/>
                <path d="M124.802 111.218L134.747 114.881V106.537L124.802 102.874V111.218Z" fill="#1989F7"/>
                <path d="M28.1621 114.639C28.1621 114.639 31.8734 120.048 38.7625 120V111.316C31.8492 111.364 28.1621 105.955 28.1621 105.955V114.639Z" fill="#1989F7"/>
                <path d="M0 81.989C0 81.989 5.70041 80.6791 8.27166 77.3559V69.2783C5.70041 72.6015 0 73.9114 0 73.9114V81.989Z" fill="#882FFC"/>
                <path d="M4.31738 33.087C4.31738 33.087 8.00446 37.3805 13.8989 36.4587V28.0172C8.00446 28.9148 4.31738 24.6455 4.31738 24.6455V33.087Z" fill="#F8D7BC"/>
                <path d="M57.2705 9.16917L63.7957 13.7295V4.56033L57.2705 0V9.16917Z" fill="#1989F7"/>
                </svg>

            </div>
            <div className="claimHeading">
                Claim
            </div>
            <div className="claimFields">
                <div className="claimBalance">
                    
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xmlSpace="preserve">  <image id="image0" width="40" height="40" x="0" y="0"
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
                      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAA
                      CXBIWXMAAAsTAAALEwEAmpwYAAAMsElEQVRYw+2YaYyd1XnHf89517vM3NlsjB0z8RjjBQOGgsEs
                      oVRAUZYiglBVlW4qUtt8aJugRApNWUrVtFBVrfKBSm1JE6lIDWqbqhSVJEoaQ1mMDY7teLyOPfbY
                      49nuzNxl7n2Xc55+uOOxjQmQQvupRzq6m+5zfu//vM//ed4D/z8+3JAPG2D6K7+3Mdi3a23NDxa8
                      VUPrvOMHt7Znq2+YUvlId1e51JiYPLzqh/sO/J8Cnv7879zeFfubG6WuW2T06H3F4wfiLIwJoxga
                      NRTIBALjUW+3Wyrmn8tR+Np8M9kzuH3vy/9rgPUH71qerr36d02p9w+KLic5+CPqJ45iURVEUKdq
                      DKKd2M6p+iJS9gyBERppTpa5J6UcfG3lf+ye+kgBzzz2xWcDP7i30NXbNzczRbbvdTVTp1XFJ2/l
                      pO2MPLOoKsYY/NAjKAT4cQiewamKh0jFM7RhppXabw9u3/fQhwbc+elLi4M3/MozPZWBX51NUtrH
                      DygHf0Q6Ncf8bEZ1rk0jycmcA1EEMAK+QOQLpUJApa9Eub+MV4hQVSJBKp7HzEL69SOnFj53x+ho
                      +38EOP6Hn7+jFJef8Qql9dXavLJ/p2b79zMz3uL0XE5LHXEkxKEQ+oLnCSKdkFYht448s5BZioGh
                      f3k35RUVJPBRp9Lre5Irw/OZ/vbQy3u3/1SA+x7YFC7bfO+B7krfmqmpCeWt7dR2H+L0rDCVWgpF
                      KMRC3QhqDAbwRDB01PPpzADwUZLUkiUZPYWQ/sF+gnIBZ5VlgSczKUdGXu7deAc/zD8Q4PjDD5b8
                      7lXfLHb1frZanXb6xveZfn2Y+sAQSQRy+jgUQp7KHEcdmMVAZnF6i5ABEIsQAJ8JhJs8w0I7o4Cy
                      fHCAoKeEyx29vm9qmX1+slX99et3jS+cz2LeDdCWV36jt9L/2Wq9ru7tV2T69WFprNoovduuFH/m
                      lHQXIwl9T8YUaYNkICmd902QGsiMIuOKHMpy2WFVTlqVsicSFkNp+55MnpyRrN4S8Y3M5rkuj/0H
                      egsDz76T5SLAyb945NIwjD891UqUQ7u1vmOfNvoGdeU9N2tjxxtaUKfzntG/T6y2rdUQ1AP1z3v1
                      QQNQY616zmrJ5bony3V35jRGNAp9TT2js2NVJc1UjNHpJNVAzL27t923/D0B8/n06VKxHGUTJ0je
                      ektmkqIsv/dOmX/zDUmnpyQuRDKvyAtJJgvWSpbl0kpzaaa5WOdEOlkiubWSOSuAeM7J9jSTHySZ
                      +CCiiPE9aVqV2sS8iEFShG5f4y7v6FM/EXD80S880NfV+8uzzbrj0F6tjs5r1x2f0HzsmNZ+vE+D
                      UkEVVFD1ba65qvq+ak9RtK8kCk7T3GpurWYuVwFlcRoVDaHznariVMU32qi1NW+01fONzmWZWxbo
                      rx255Zr7zjL55wNqkl5LEKKjR6V9aIRs5RqiAkx8dzt+HHeiS8dCWgqt3HLP+m4G+yKMGN4cbbDr
                      ZAPfCIKg52WiAgGCLH7u/K6kQKPaoLergD37vQm3AP9ykYIaF36uneWOsRFdaIpmpaJOv7xdPWPU
                      +EYRWVJFnWop9LWnXFAQbSWZblkV642DXZpaVQXtSIVa51RVNZBF9c4qCYox2lpI1CWZGs9o4qxT
                      cXdepOCZP3nsFwpBeGN9ekLd9BS11Gf68EF6i2CiEF3SA3LniOOQL/3SbawoCq12QpblzM7MsDad
                      4pKuXkSE3FqctZRKRV44Wsdr50t77gCnHTlTq6QLCVFvmXqS0+MnNx/5xJZPXr5994tLgNnU+FDl
                      sstVqxPqGm0aCwmh5wiCEBEQMUtbI85RiAKu33ojseTUqpPkrTrLlvVTKpWYGh8nCgyVSoVKb4X+
                      vh52zOwiPFVd8syzk0XgLLUUohib1IjEF5vI0AUKGk+a6iw6OSZZBpm1RAWDipzn5oIqlDG0mm2+
                      8lfPUY4jnCq1Wp27t3yMGzd9nGpL+ddXhxnos/jBPKqjnJycZ9opidNOsaYjnwioCFlqIYwAcBh1
                      fql5IWDfihvc8UMq1UmseoDDN4KRzg1/tlIkAse6DQUXsHb1JYTiCP2Yel+FcrFA2k7o7eth3cYr
                      iX2fRquJVQGZZXhZFzO5o1fPNRUAIuCyHDEeRgxgiczCDcDXz23x269e366eEfUDnEs7VyiGs3e0
                      AJ4qdQ+Gl/lUNOQ377+bQs8Ktu95lcsv24BfPc3EyB6Ghtaz6dYhDp44zNYNW6BdY/TJv+b69QPU
                      956ku5WixixqeDbrFDVeR01nsWnrhguyWJq1/4riQsezDOrJkquc52eqMWgJUV9Em622zmeBvrR3
                      vx6ZaSh+QT2cmqCow9VMv/XGDp23ZW22Em22Ev3bf39b2422+sYs+ul504iKZxRVDcXT3AavXADo
                      XXPjiHT1iForXmDEiIgqonSmgCwo8lo7l+mWlcGegvieEZk9LI996lOypZjK7NiwEJZk7vQhuUIn
                      5av33S/B/GFRlwsgxSCQqkMSp+JUl2KrqnhhIBgj6qwgRkxUHrkAUM+MrZTGPBijQeRp5HvqnHau
                      TtFQRKdV9am5ln7rwJwOFFVr9ZoqohY0Dox2F0Lt761odzHSUBON4lBFRNMsU5tbzUX0z1qpHsis
                      houeKqDinIblUmennFODw3PNlRckSXLs4M62ZwQxmBgKhZD5pNnxVYFEYbXn8ceVAo/Mt/jm6yf4
                      /pF/4JlHf4vRUxO8uH0XvjmX77kd47KVp7jlug18+S+fY2x6jt8oRlzpGZb5hrONnwLGOcK+HlyS
                      IAgLSSatanPnBYBD//njfzx+17V/VFR3eRtHd6VA7VSj84yxaDSKcl0U8Fg3fGmmTjPN6C4X2Hd4
                      lOe+89o7+w6uW3cZd267mtNTVVrWscYz3BoH1FSXEgRVotAnGugjnxyn6HtUW3LgqoPH/umiWuz3
                      DeyN56bXLVhLsb9APBGQZ47AdBCtdALeFAd8safIn7dTvvD0N5irNVnVU+b+2zbgnBL6HvtPTLPz
                      yBR/+uy3MQoPliIu8w11Vdx52UuWU1q9Agk8XLNBFEUEcbTnXZuFbLa606jej+L8kkf/QBdnJqsQ
                      eoh0/MYKGFV+vhgx45Rn9hwC4Pc/cz0P3L6RJM0JPMPNG1cxPPYDvrdjH2EccXepwJBvaOn5N74S
                      idJ1xRrs9DSCYJyarFnfea40nN8sgDl2+6aXK0GwrZ7nkML48DgLxhLGQSeXF30xBFJV/qbR5vlW
                      xl1bBukrRlinGIEoDti19ySlmTrlwOfBQsiawJDruYWlnbBs/RrKV6yhfXA/3UHI1MzCK5v2H//Z
                      xXJ9oYICbjQKH/fhO6I4iQ3LVvcyfmwS51u8wOuUJ4UMJRT4XDmirfDCmyO0nVuqtTmwOg74aneB
                      Xs+jJZDreTU4zaj0ddO96QqSkcN4YhAVkyTRY2fhLrCZJcju+JXpVnq84nsmt06C/oIsX9UrppWL
                      zdxZ1xFAUkUMIg+VQumKfIkKoUSFUPw4lEohlBtCX4yIZIs+utQjpLmUipH03bJV0jOnxC4sSCUI
                      zEw7OzIua159h2gXj7evGfz4QKX4vcj31zatc54Rkok60+Nz5IHBBB4slhcDOFW+XGuxJ3P0GKGl
                      ys2Bx8OlqFN/AFlsOiRJ6OrtYuDWrdi5Ktn4aUpRZGpzrcNnxubuvG129sT7AgIM33HVzyz3ZGdq
                      HS2r6nkGV2sxNz7HQpqjvod4sgTZcI5J6ygt3qcRUJbFqwDEWgIcPUOr6d68gWxinHxqkmIciSaW
                      kZH6tbdOnd590Y7yHmN42/onejzziBd4fiN3zvM9jHW0q00ac02SNMeJgBE8AaNgnaIozoF1DuMc
                      gW8oLe+j+4o1+F0l0pOj2OYC5TA0WZpncwv5k5v3jTz5bgzvfzZz1eBNK3qKz5fC4GPzWY4i6vkG
                      rJI3E5JmQpZk5LlFrcNpRzLjeQTFmLi/h3h5P14xxs7Pks/MIGKkJ/SZmW2fOD42+8Cd1eqOn7T+
                      Bzrd2r9tw+YujxdiMYPOExq5U2NEjedhzOI2Orf4BAISBEixiPg+6hx2oYlrNHGqUg4CIXe0Mnt8
                      fKz+yW1nzgy/19of+PjtaSjdc+Vl93RVCo8vL0Sb29bRco7EdbpP6TwXnPuDc2huASXyPCl4HhHC
                      qerCntnZ1uMvjo2/9AQsvN+6P/UJ60tXX1JaF1eeyDO7UQLZuqwYDwAdpYBElUgEDxAjOKucmW9N
                      GeFNY2T/v7098ujD0Pqg632oM+rvruzqX7v60odsmg/V2llWKoXr4sC/slZP96VZfri/OwrTtjuy
                      e+/03/0iteqHWesjGzu5tPhRxvtvrL2iClFhHX8AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDQt
                      MjlUMDc6MTM6MjYrMDM6MDCmacO7AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA0LTI5VDA3OjEz
                      OjI2KzAzOjAw1zR7BwAAAABJRU5ErkJggg==" />
                    </svg>

                    <span>Red Balance:{" "}</span>&nbsp;&nbsp;
                    <div>{cliffTokenBalance
                        ? formatter.format(formatUnits(cliffTokenBalance, 18))
                        : 0}</div>
                </div>
                <form className="claimAmtInpSec">
                    <input
                        type= "text"
                        pattern= "[0-9]*"
                        className="claimAmtInp"
                        placeholder="Enter CLAIM Amount"
                        // value={stakingCLIFFAmount > 0 ? stakingCLIFFAmount : ""}
                        // onChange={({ currentTarget }) => {
                        // setStakingCLIFFAmount(Math.floor(parseFloat(currentTarget.value)));
                        // }}
                        id="eth"
                        onFocus={()=>{
                            document.getElementsByClassName('claimAmtInpSec')[0].style.border='1px solid white'
                          }}
                          onBlur={()=>{
                            document.getElementsByClassName('claimAmtInpSec')[0].style.border='1px solid #1F1F1F'
                          }}
                    />
                    <button type="button" className="claimMaxBtn"
                    //  onClick={() => {
                    //     setStakingCLIFFAmount(Math.floor(formatUnits(cliffTokenBalance, 18)));
                    //     }}
                    >
                        Maximum
                    </button>
                </form>
                <div className="claimBalance">
                        
                    <span>Estimated ETH Amount:{" "}</span>&nbsp;&nbsp;
                    <div>{formatter.format(
                        totalSupplyF > 0
                        ? parseFloat(
                            (rewardPerBlockF * 6200 * stakingCLIFFAmount) / totalSupplyF
                            ).toFixed(2)
                        : 0
                    )}</div>
                </div>
                <div className="claimBalance">
                        
                    <span>Total ETH claimed:{" "}</span>&nbsp;&nbsp;
                    <div>{formatter.format(
                        totalSupplyF > 0
                        ? parseFloat(
                            (rewardPerBlockF * 6200 * stakingCLIFFAmount) / totalSupplyF
                            ).toFixed(2)
                        : 0
                    )}</div>
                </div>
                <div className="claimBtnSec">
                    <button className="claimBtn">Claim ETH</button>
                </div>
            </div>
        </div>
  </DashboardLayout>) : (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="info" display="inline-block">
          CONNECT FIRST to view your CLIFFORD Portfolio
        </MDTypography>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Claims